import React, { Fragment, useState, useEffect } from 'react';

import { getIndentClass } from '../../utils/styleUtils';

import SponsorCostcenterRow from './SponsorCostcenterRow';
import SponsorRow from './SponsorRow';

import ChevronDownIcon from 'Assets/icons/chevron-down.svg';
import ChevronUpIcon from 'Assets/icons/chevron-up.svg';

function SponsorDepartmentRow(props) {
    const [showDepartment, setShowDepartment] = useState(false);

    // Handle expand all trigger from parent with staggered updates
    useEffect(() => {
        const t = props.expandAllTrigger;
        if (!t?.version) return;

        if (t.batch === 'departments') {
            setShowDepartment(t.expanded);
        }
    }, [props.expandAllTrigger?.version]);

    // Calculate indentation level (base level for department)
    const indentLevel = props.indentLevel || 0;
    const childIndentLevel = indentLevel + 1;

    return (
        <>
            <tr className="!tw-bg-blue-25">
                <td className="tw-font-bold tw-cursor-pointer !tw-border-r-0" onClick={() => setShowDepartment(!showDepartment)}>
                    <div className={`tw-flex tw-items-center tw-gap-x-1.5 ${getIndentClass(indentLevel)}`}>
                        <div className="!tw-text-blue">{props.department.name}</div>
                        <div>{showDepartment ? <ChevronUpIcon /> : <ChevronDownIcon />}</div>
                    </div>
                </td>
                <td className="tw-p-4 !tw-border-x-0"></td>
                <td className="tw-font-bold tw-cursor-pointer tw-border-r-2" onClick={() => setShowDepartment(!showDepartment)}></td>
                <td
                    colSpan={props.maxSponsorMilestonesCount * 2 + 3}
                    className="tw-font-bold tw-cursor-pointer !tw-border-l-0"
                    onClick={() => setShowDepartment(!showDepartment)}
                ></td>
            </tr>

            {showDepartment && (
                <Fragment>
                    {props.department.costcenters &&
                        props.department.costcenters.length > 0 &&
                        props.department.costcenters.map((costcenter) => {
                            return (
                                <SponsorCostcenterRow
                                    SponsorMilestoneUpdateUrl={props.SponsorMilestoneUpdateUrl}
                                    minDate={props.minDate}
                                    maxDate={props.maxDate}
                                    key={`tr_costcenter_${costcenter['id']}`}
                                    costcenter={costcenter}
                                    maxSponsorMilestonesCount={props.maxSponsorMilestonesCount}
                                    increaseMaxMilestonesCount={props.increaseMaxMilestonesCount}
                                    editingSponsorId={props.editingSponsorId}
                                    editingType={props.editingType}
                                    editingMilestoneId={props.editingMilestoneId}
                                    editingMilestoneType={props.editingMilestoneType}
                                    setSponsorEditing={props.setSponsorEditing}
                                    modalShow={props.modalShow}
                                    fetchCentralCashflow={props.fetchCentralCashflow}
                                    canEdit={props.canEdit}
                                    costcentersColor={props.costcentersColor}
                                    milestoneType={props.milestoneType}
                                    periods={props.periods}
                                    setLoading={props.setLoading}
                                    indentLevel={childIndentLevel}
                                    expandAllTrigger={props.expandAllTrigger}
                                    editAllTrigger={props.editAllTrigger}
                                />
                            );
                        })}
                    {props.department.sponsors &&
                        props.department.sponsors.length > 0 &&
                        props.department.sponsors.map((sponsor) => {
                            return (
                                <SponsorRow
                                    SponsorMilestoneUpdateUrl={props.SponsorMilestoneUpdateUrl}
                                    minDate={props.minDate}
                                    maxDate={props.maxDate}
                                    key={`tr_sponsor_${sponsor.id}`}
                                    sponsor={sponsor}
                                    maxSponsorMilestonesCount={props.maxSponsorMilestonesCount}
                                    increaseMaxMilestonesCount={props.increaseMaxMilestonesCount}
                                    editingSponsorId={props.editingSponsorId}
                                    editingType={props.editingType}
                                    editingMilestoneId={props.editingMilestoneId}
                                    editingMilestoneType={props.editingMilestoneType}
                                    setSponsorEditing={props.setSponsorEditing}
                                    modalShow={props.modalShow}
                                    fetchCentralCashflow={props.fetchCentralCashflow}
                                    canEdit={props.canEdit}
                                    milestoneType={props.milestoneType}
                                    periods={props.periods}
                                    setLoading={props.setLoading}
                                    indentLevel={childIndentLevel}
                                    expandAllTrigger={props.expandAllTrigger}
                                    editAllTrigger={props.editAllTrigger}
                                />
                            );
                        })}
                </Fragment>
            )}
        </>
    );
}

// Memoize component to prevent unnecessary re-renders
export default React.memo(SponsorDepartmentRow);
